import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function QuickPlayerRegistration({ recentPlayers, onSubmit }) {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");

    const save = async () => {
        if (!name.trim() || !phone.trim()) { toast.error("Enter name and phone"); return; }
        try {
            await onSubmit({ name: name.trim(), phone: phone.trim() });
            toast.success(`${name} added`);
            setName(""); setPhone("");
        } catch {
            toast.error("Failed to add player");
        }
    };

    return (
        <Card className="card-lux">
            <CardContent className="p-6">
                <div className="flex items-center gap-2 mb-4">
                    <UserPlus weight="duotone" size={22} className="text-gold" />
                    <h3 className="font-serif text-xl">Quick registration</h3>
                </div>
                <div className="space-y-3">
                    <div>
                        <Label className="label-mini">Name</Label>
                        <Input data-testid="input-player-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. John Doe" />
                    </div>
                    <div>
                        <Label className="label-mini">Phone (E.164)</Label>
                        <Input data-testid="input-player-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+15551234567" />
                    </div>
                    <Button data-testid="btn-save-player" onClick={save} className="btn-gold w-full h-11">Save player</Button>
                </div>
                <div className="mt-6 pt-5 border-t border-border">
                    <div className="label-mini mb-2">Recent players</div>
                    <div className="space-y-1 max-h-52 overflow-y-auto pr-1" data-testid="recent-players">
                        {recentPlayers.slice(0, 8).map(p => (
                            <div key={p.id} className="flex justify-between text-sm py-1 border-b border-border/40">
                                <span>{p.name}</span>
                                <span className="text-muted-foreground font-mono-plex text-xs">{p.phone}</span>
                            </div>
                        ))}
                        {!recentPlayers.length && <div className="text-sm text-muted-foreground">No players yet.</div>}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
